export default __webpack_public_path__ + "static/digital_marketing_service_features-c29ab4b260e4bad2462555d8dff96c06.svg";